import { render, staticRenderFns } from "./unifiedTask.vue?vue&type=template&id=5b7715d6&"
import script from "./unifiedTask.vue?vue&type=script&lang=js&"
export * from "./unifiedTask.vue?vue&type=script&lang=js&"
import style0 from "./unifiedTask.vue?vue&type=style&index=0&id=5b7715d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports